/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var paymentApi = require('./payment-api.service');
var handleServiceError = require('./handle-error.service');
var loading = require('./loading.service');
var listRequest = require('../list/list-request');
var localize = require('./localize.service');
var rootScope = require('./root-scope.service');
var utils = require('./util/common-utils');
const { openLightbox, removeLightbox } = require('./lightbox');
const { showGlobalInfoMessage, showGlobalErrorMessage } = require('./util/global-message');
const { isUpdateWithPending } = require('./util/operate-utils');
const { RiskPlugin } = require('../../plugins/riskPlugin');
const { providerRedirect } = require('./provider-redirect.service');

function reInit(callback) {
    listRequest(callback);
}
/**
 * Performs the specific operation.
 *
 * @param account The account to be charged or updated
 */
function operate(account) {
    var selectedNetwork = rootScope.getSelectedNetwork();
    // retrieve existing operation or create a new one (usually for registered accounts)
    var existingOperation = rootScope.getOperations(selectedNetwork);
    var operation = existingOperation ? existingOperation : {};
    operation.account = account;
    var operationLink = selectedNetwork.links.operation;

    const operationType = rootScope.getOperationType();
    if (operationType === 'charge' || operationType === 'preset') operation.providerRequests = RiskPlugin.getRiskData();

    var operationLink = rootScope.getSelectedNetwork().links.operation;
    paymentApi.operationRequest(operationLink, operation, operateCallback);
}
/**
 * @returns {Boolean} true if its summary page and has onResult custom function
 * else false
 */
const hasOnResultFunction = () => glob?.summaryPage && glob?.summaryPageHandler?.onResult;

/**
 * The operate callback method.
 *
 * @param data The data returned from the callback
 */
function operateCallback(err, data) {
    if (err) {
        return handleServiceError(err);
    }
    switch (data.interaction.code) {
        case 'PROCEED':
            RiskPlugin.destroy();
            var containsPlaceholders = data && data.redirect && data.redirect.containsAccountPlaceholders;
            if (containsPlaceholders) {
                replacePlaceholders(data.redirect, data.requestAccount);
            }
            const isLightbox = shouldOpenLightbox({
                type: data.redirect?.type,
                integrationType: rootScope.getIntegrationType(),
                hostedVersion: rootScope.getHostedVersion(),
            });
            const shouldShowGlobalInfoMessage = isUpdateWithPending({
                isUpdate: rootScope.isUpdate(),
                redirect: data.redirect,
                reason: data.interaction?.reason,
            });
            if (shouldShowGlobalInfoMessage) {
                showGlobalInfoMessage(rootScope.getListContainer(), rootScope.getLanguage());
                loading.submitButtonNormal();
            }
            if (isLightbox) {
                handleLightbox(data.redirect);
            } else if (data.redirect?.method == 'GET' && data?.redirect?.type === 'PROVIDER' && rootScope.isProviderRedirectEnabled()) {
                rootScope.setIsCancelEventFired(false);
                providerRedirect(data, glob.providerRedirectWindowSpecs, operateCallback);
            } else if (hasOnResultFunction()) {
                glob.summaryPageHandler.onResult(data);
            } else if (rootScope.hasProceedFunction()) {
                /**
                 * proceed function is passed, before calling it check if it is 3DS2,
                 * then we dont call proceed function(even full page or not)
                 * after the message (from LB), then the proceed function should be called
                 *  */
                rootScope.proceedFunction(data);
                // hide submit loading (full page)
                loading.submitButtonNormal();
            } else if (data.redirect?.method == 'GET') {
                utils.redirect(data.redirect);
            } else {
                formSubmit(data.redirect);
            }
            break;

        case 'ABORT':
            RiskPlugin.destroy();
            if (rootScope.hasAbortFunction()) {
                rootScope.abortFunction(data);
            } else if (rootScope.hasProceedFunction()) {
                rootScope.proceedFunction(data);
            } else {
                utils.redirect(data.redirect);
            }
            // hide submit loading (full page)
            loading.submitButtonNormal();
            break;

        case 'TRY_OTHER_ACCOUNT':
        case 'RETRY':
            if (rootScope.hasProceedFunction()) {
                rootScope.proceedFunction(data);
            } else {
                showGlobalErrorMessageFromResponse(data);
            }
            // hide submit loading (full page)
            loading.submitButtonNormal();
            break;

        case 'TRY_OTHER_NETWORK':
        case 'RELOAD':
            RiskPlugin.destroy();
            if (rootScope.hasProceedFunction()) {
                rootScope.proceedFunction(data);
            } else {
                //OPTILE-5219: reload list (with state cleanup logic!) and show operate-result-message
                rootScope.getListContainer().html('');
                $('.' + rootScope.getSpecialButtonsClass()).html('');
                reInit(function () {
                    showGlobalErrorMessageFromResponse(data);
                });
            }
            // hide submit loading (full page)
            loading.submitButtonNormal();
            break;
        case 'VERIFY':
            RiskPlugin.destroy();
            if (rootScope.hasAbortFunction()) {
                rootScope.abortFunction(data);
            } else if (rootScope.hasProceedFunction()) {
                rootScope.proceedFunction(data);
            } else {
                rootScope.getListContainer().html('');
                showGlobalErrorMessageFromResponse(data);

                $('#' + rootScope.getPayButtonContainer()).hide();
            }
            // hide submit loading (full page)
            loading.submitButtonNormal();
            break;
    }
}
/**
 * A form is dynamically created to POST the finalize the payment.
 *
 * @param redirectData The data containing the information to create and submit a form
 */
function formSubmit(redirectData) {
    var form = $('<form method="post" action="' + redirectData.url + '"></form>');
    var input;
    var i;
    var params = redirectData.parameters;
    var suppress = redirectData.suppressIFrame !== undefined ? redirectData.suppressIFrame : rootScope.getSuppressIFrameDefault();
    var value;

    if (suppress) {
        form.attr('target', '_top');
    }

    if (params) {
        for (i = 0; i < params.length; i++) {
            value = params[i].value ? params[i].value.replace("'", `\'`) : '';
            input = $('<input type="hidden" name="' + params[i].name + '" value="' + value + '">');
            form.append(input);
        }
    }

    $('body').append(form);
    form.submit();
}

/**
 * Show Global Error Message From Response of Api Call
 * @param {Object} apiResponse
 */
function showGlobalErrorMessageFromResponse(apiResponse) {
    showGlobalErrorMessage(
        rootScope.getListContainer(),
        localize.translate(
            'interaction.' + apiResponse.interaction.code + '.' + apiResponse.interaction.reason + '.text',
            rootScope.getPageTranslation()
        ),
        localize.translate(
            'interaction.' + apiResponse.interaction.code + '.' + apiResponse.interaction.reason + '.title',
            rootScope.getPageTranslation()
        )
    );
}

function replacePlaceholders(redirectData, account) {
    if (redirectData && redirectData.parameters && account) {
        var params = redirectData.parameters;
        for (var i = 0; i < params.length; i++) {
            var param = params[i];
            if (param && param.value) {
                param.value = param.value.replace(/\${(.*?)}/g, function (match, placeholder) {
                    if (placeholder && placeholder.startsWith('account.')) {
                        //8 == 'account.'.length
                        return account[placeholder.substring(8)];
                    }
                    return '';
                });
            }
        }
    }
}

/**
 * Handles the lightbox case
 * @param {Object} redirect redirect data from the charge response
 */
const handleLightbox = (redirect) => {
    loading.hidePaymentLoading();
    const challengeWindowSize = redirect.parameters.find((param) => param.name === 'challengeWindowSize');
    const suppress = redirect.suppressIFrame !== undefined ? redirect.suppressIFrame : rootScope.getSuppressIFrameDefault();
    const parameters = [
        ...redirect.parameters,
        { name: 'isLightbox', value: true },
        { name: 'targetOrigin', value: window.location.origin },
        { name: 'suppress', value: suppress },
        { name: 'logoUrl', value: document.querySelector('label img.active')?.src },
    ];
    let redirectUrl = utils.constructQueryParams(redirect.url, parameters);
    openLightbox(redirectUrl, challengeWindowSize);
    rootScope.setMessageListener(addIframeListener(redirectUrl));
};

/**
 * The function which initiates the event listener on messages
 * sent from iframe. It checks with the redirect url which actually
 * initiates the lightbox. To secure whether the message is sent from
 * authorized domain
 */
function addIframeListener(redirectUrl) {
    window.addEventListener('message', function (event) {
        // TODO: handle the unique message type (of the event listener) sent from the lightbox
        if (redirectUrl.includes(event.origin)) {
            let message = event.data;
            try {
                message = typeof message === 'string' ? JSON.parse(message) : message;
            } catch (err) {
                console.warn('Caught unexpected message format');
            }
            switch (message?.messageType) {
                case 'HIDE_LOADER':
                    const loader = document.getElementById('lb-overlay-loader');
                    loader?.classList.add('op-payment-widget-hide');
                    break;
                case 'CLOSE_LB':
                default:
                    if (message?.data?.redirect) {
                        const data = { ...message.data, redirect: { ...message.data.redirect, suppressIFrame: message.suppress } };
                        removeLightbox();
                        const showLoader = !hasOnResultFunction() && !rootScope.hasProceedFunction();
                        if (showLoader) loading.showPaymentLoading();
                        operateCallback(null, data);
                    }
                    break;
            }
        }
    });
}

const SUPPORTED_HOSTED_VERSIONS = ['v4'];

const shouldOpenLightbox = ({ type, integrationType, hostedVersion }) =>
    type === '3DS2-HANDLER' &&
    (integrationType !== 'HOSTED' || (integrationType === 'HOSTED' && SUPPORTED_HOSTED_VERSIONS.includes(hostedVersion)));

module.exports = {
    operate,
    operateCallback, //used if the operate is done in other frame
    addIframeListener,
};
